import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { DigestionPartCreateForm } from "./components/DigestionPartCreateForm";

export function NewDigestionPartPage() {
  return (
    <LqsPage title="New Digestion Part">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionPartCreateForm />
      </Container>
    </LqsPage>
  );
}
